import Dexie, { type Table } from "dexie";
import { File, type FileData } from "$lib/wasm/file";

export type FileInfo = Omit<FileData, "data">;

// Dexie js db schema
export const FileDataSchema = "++id, name";

export class EditorDexie extends Dexie {
    fileInfo!: Table<FileInfo>;
    fileData!: Table<{ id: number; data: Uint8Array }>;

    constructor() {
        super("editor-db");

        this.version(1).stores({
            fileInfo: FileDataSchema,
            fileData: "++id",
        });
    }

    /// Files
    async getFile(id: number, fileInfo?: FileInfo) {
        let [info, data] = await Promise.all([
            fileInfo ?? this.fileInfo.get(id),
            this.fileData.get(id),
        ]);

        if (!info || !data) return null;

        return await File.load({
            ...info,
            data: data.data,
        });
    }

    async putFile(fileData: FileData) {
        let { id, data } = fileData;
        delete (fileData as any).data;

        if (id) {
            await Promise.all([
                this.fileInfo.put(fileData, id),
                this.fileData.put({ id, data }, id),
            ]);
            return id;
        } else {
            const id = await this.fileInfo.put(fileData);
            await this.fileData.put({ id, data }, id);
            return id;
        }
    }

    async deleteFile(id: number) {
        await Promise.all([this.fileInfo.delete(id), this.fileData.delete(id)]);
    }

    async getFiles() {
        return this.fileInfo.toArray();
    }
}

export const db = new EditorDexie();
